import {type ClassValue, clsx} from "clsx"
import {twMerge} from "tailwind-merge"

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const sleep = async (ms: number) => await new Promise(resolve => setTimeout(resolve, ms))

export {
  sleep, cn
}
